import {
  BASE_URL_WMS_BPJS,
  DEFAULT_BOX_SHADOW,
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance1,
  PRIMARY_BACKGROUND,
  TYPE_INSTANCE1,
  V1,
} from "App/constants";
import {
  InputCheckboxMaster,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import { Grid, Paper } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
} from "App/utils/helpers";
import { SearchIcon } from "App/Assets";
import ModalBridge from "./ModalBridge";
import { LIST_URL_MASTER } from "utils/masters";

export const getAllPoliklinik = async () => {
  try {
    const api = await instance1.get(LIST_URL_MASTER.poliklinik.list);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

export const deletePoliklinikById = async (
  id,
  setRows,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance1.post(
      LIST_URL_MASTER.poliklinik.delete,
      {},
      {
        headers: {
          idpoliclinic: id,
        },
      }
    );
    setShowModalDeleteConfirm(false);
    const newData = await fetchData(
      TYPE_INSTANCE1,
      LIST_URL_MASTER.poliklinik.list
    );
    setRows(newData);
    setFormData({
      id: "",
      name: "",
      code: "",
    });
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "code",
    disablePadding: false,
    label: "KODE",
    align: "left",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "no_poli",
    disablePadding: false,
    label: "NO POLI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "kodebridge",
    disablePadding: false,
    label: "KODE BRIDGE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const RESET_STATE_POLIKLINIK = {
  id: "",
  name: "",
  code: "",
  no_poli: "",
  kodebridge: "",
  status: 1,
  remark: "-",
};
export const ModalForm = ({ formData, setFormData, setRows }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const [rowsBridge, setRowsBridge] = useState([]);
  const [showModalBridge, setShowModalBridge] = useState(false);

  const addPoliklinik = async () => {
    return instance1.post(LIST_URL_MASTER.poliklinik.add, {
      ...formData,
    });
  };

  const updatePoliklinik = () => {
    return instance1.post(
      LIST_URL_MASTER.poliklinik.update,
      {
        ...formData,
      },
      {
        headers: {
          idpoliclinic: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.name === "" || formData.code === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama dan Kode tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await addPoliklinik();
          defaultToastSuccess("Berhasil menambah poliklinik");
        } else if (formData.id !== "") {
          await updatePoliklinik();
          defaultToastSuccess("Berhasil mengubah poliklinik");
        }
        const newData = await fetchData(
          TYPE_INSTANCE1,
          LIST_URL_MASTER.poliklinik.list
        );
        setRows(newData);
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormData(RESET_STATE_POLIKLINIK);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const setNewData = async () => {
    const res = await getDataPoliklinikBridge();
    if (res.state) {
      setRowsBridge(res.data);
    }
  };

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []);

  return (
    <>
      {showModalBridge && (
        <ModalBridge
          rowsBridge={rowsBridge}
          setRowsBridge={setRowsBridge}
          formData={formData}
          setFormData={setFormData}
          setShowModal={() => setShowModalBridge(false)}
        />
      )}
      <Paper
        style={{
          width: "100%",
          margin: "0",
          padding: "1rem 1.5rem",
          backgroundColor: PRIMARY_BACKGROUND,
          boxShadow: DEFAULT_BOX_SHADOW,
        }}>
        <form action='POST' onSubmit={(e) => handleSubmit(e)}>
          <Grid container spacing={1}>
            <InputTextMaster
              type='hidden'
              name='id'
              id='id'
              readOnly={true}
              value={formData.id}
            />
            <Grid item sm={3}>
              <InputTextMaster
                name='code'
                label='Kode'
                id='code'
                value={formData.code}
                onChange={handleChange("code")}
                placeholder='Kode'
              />
            </Grid>
            <Grid item sm={3}>
              <InputTextMaster
                name='name'
                label='Nama'
                id='name'
                value={formData.name}
                onChange={handleChange("name")}
                placeholder='Nama'
              />
            </Grid>
            <Grid item sm={4}>
              <InputTextMaster
                name='no_poli'
                label='NO POLI'
                id='no_poli'
                value={formData.no_poli}
                onChange={handleChange("no_poli")}
                placeholder='No Poli'
              />
            </Grid>

            <Grid item sm={2}>
              <div className='mt-2'>
                <InputCheckboxMaster
                  checked={formData.status}
                  name='status'
                  id='status'
                  label='Aktif'
                  onChange={() =>
                    setFormData({ ...formData, status: !formData.status })
                  }
                />
              </div>
            </Grid>

            <Grid item sm={6}>
              <InputTextMaster
                name='kodebridge'
                label='KODE BRIDGE'
                id='kodebridge'
                value={formData.kodebridge}
                placeholder='Pilih Kode Bridge'
                disabled={true}
                withButton={true}>
                <button
                  type={"button"}
                  onClick={() => setShowModalBridge(!showModalBridge)}
                  style={{
                    borderRight: "1px solid #EAEAEA",
                    borderTop: "1px solid #EAEAEA",
                    borderBottom: "1px solid #EAEAEA",
                    borderLeft: "0",
                    background: "#fff",
                    padding: "0 0.8rem",
                    cursor: "pointer",
                    borderRadius: "0 6px 6px 0",
                  }}>
                  <SearchIcon width={"16"} height={"16"} fill={"#333"} />
                </button>
              </InputTextMaster>
            </Grid>

            <Grid item sm={6}>
              <InputTextMaster
                name='remark'
                label='CATATAN'
                id='remark'
                value={formData.remark}
                onChange={handleChange("remark")}
                placeholder='Catatan'
              />
            </Grid>
          </Grid>

          <div className='mt-1'>
            <Grid
              container
              direction='row'
              justifyContent='space-between'
              alignItems='center'>
              <MasterButton
                className={"mt-1"}
                type='button'
                color={"danger"}
                name={"RESET"}
                onClick={() => setFormData(RESET_STATE_POLIKLINIK)}
                size='md'
              />
              <MasterButton
                className={"mt-1"}
                type='submit'
                color={disabled.color}
                name={disabled.label}
                size='md'
              />
            </Grid>
          </div>
        </form>
      </Paper>
    </>
  );
};

export const getDataPoliklinikBridge = async () => {
  try {
    const api = await instance1.get(`/bridging`, {
      headers: {
        method: "get",
        url: `${BASE_URL_WMS_BPJS}/${V1}/rsannisa/ws/bpjs/referensi/poli`,
      },
    });
    if (api.data?.body?.response?.list.length > 0) {
      return {
        state: true,
        data: api.data?.body?.response?.list,
      };
    }

    return {
      state: true,
      data: [],
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    };
  }
};
